<template>
  <Entity :type="'group'" :size="size">
    <template slot="title">
      <ListInline divided>
        <li v-if="entityname">
          <span class="text-bold">
            <slot :entityname="entityname" name="entityname">
              {{ entityname }}
            </slot>
          </span>
        </li>
        <li v-else class="text-muted">
          {{ nameFallback }}
        </li>
      </ListInline>
    </template>
    <template slot="body">
      <slot name="body" />
    </template>
    <template slot="actions">
      <slot name="actions" />
    </template>
  </Entity>
</template>

<script>
import Entity from '@/components/ui/Entity';

export default {
  components: {
    Entity,
  },

  props: {
    users: {
      type: Array,
      default: null,
    },
    /**
     * The entity size:
     * `large`
     */
    size: {
      type: String,
      default: null,
    },
  },

  computed: {
    entityname() {
      return this.users.map(user => this.singleEntityName(user)).join(', ');
    },
  },

  methods: {
    singleEntityName(singleUser) {
      if (singleUser.type === 'bus') {
        if (singleUser.details && singleUser.details.current_course) {
          const {
            driver_first_name,
            driver_last_name,
          } = singleUser.details.current_course;
          return `${driver_first_name} ${driver_last_name}`.trim();
        } else {
          return `Bus ${singleUser.details.vehicle_no}`;
        }
      } else {
        const { first_name, last_name } = singleUser;
        return `${first_name} ${last_name}`.trim();
      }
    },
  },
};
</script>
